import TransactionType from "@/models/Accounts/Shared/Transactions/TransactionType";

export default (transactionType: TransactionType) => {
    let returnVal = transactionType;
    if (transactionType === TransactionType.domesticMotoFx) {
        return "WALLET_FX";
    }
    if (transactionType === TransactionType.cardSchemeInterchangeFee) {
        return "WALLET_FX_FEE";
    }
    return returnVal;
}